import {
  getYouTubeThumbnail,
  getYouTubeVideoId,
} from "../../utils/videoHelpers"
import { convertToEmbedUrl } from "../../modifications/convertLiveStreamUrl"

export const liveStreamCountdown = (livestreamEl, componentClass) => {
  if (!livestreamEl) return

  const countdownTime = livestreamEl.dataset.livestreamStartTime
  let countdownDisplayEl = livestreamEl.querySelectorAll(
    `.${componentClass}__livestream-countdown:not(.${componentClass}__livestream-countdown--not-overlay)`,
  )

  if (!countdownDisplayEl) {
    countdownDisplayEl = livestreamEl.querySelectorAll(
      ".video--livestream__livestream-countdown:not(.video-page__livestream-countdown--not-overlay)",
    )

    if (!countdownDisplayEl) {
      return
    }
  }

  if (!countdownTime) {
    return
  }

  let autoplayOnCountdownEnd = false

  const videoId = getYouTubeVideoId(
    convertToEmbedUrl(livestreamEl.dataset.liveUrl),
  )
  const countdownDate = new Date(countdownTime)

  function pad(num) {
    return String(num).padStart(2, "0")
  }

  /* eslint-disable no-extra-semi */
  ;[...countdownDisplayEl].forEach((el) => {
    const countdownWrapperEl = livestreamEl.querySelector(
      `.${componentClass}__livestream-countdown-content-wrapper`,
    )
    const thumbnailImg = getYouTubeThumbnail(videoId)
    const imgElement = document.createElement("div")
    imgElement.style.background = `url(${thumbnailImg})`
    imgElement.style.backgroundSize = "cover"
    imgElement.style.backgroundPosition = "center"
    imgElement.style.width = "100%"
    imgElement.style.height = "100%"
    imgElement.style.backgroundRepeat = "no-repeat"
    imgElement.style.position = "absolute"
    imgElement.style.top = "0"
    imgElement.style.left = "0"
    imgElement.alt = "Livestream Thumbnail"
    imgElement.className = `video-player__thumbnail`

    const videoPlayerEl = livestreamEl.querySelector(".video-player")
    videoPlayerEl.appendChild(imgElement)

    const ytEl = livestreamEl.querySelector(".video-player__player")

    function updateCountdown() {
      const now = new Date()
      const timeLeft = countdownDate - now

      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24))
      const hours = Math.floor(
        (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      )
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000)

      // Use seconds for more accurate interval, but do not display
      if (
        timeLeft <= 0 ||
        (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0)
      ) {
        imgElement.remove()
        countdownWrapperEl.style.display = "none"
        el.textContent = "Live Now"
        if (autoplayOnCountdownEnd && ytEl) {
          ytEl.autoplay = "1"
          ytEl.muted = true
          ytEl.play()
        }

        /* eslint-disable no-use-before-define */
        clearInterval(countdownInterval)
        return
      }

      autoplayOnCountdownEnd = true

      el.innerHTML = `
      <span class="livestream-countdown-digits h4 mr--large"><i>${pad(
        days,
      )} </i></span>
      <span class="livestream-countdown-digits h4"><i>${pad(hours)}:</i></span>
      <span class="livestream-countdown-digits h4"><i>${pad(
        minutes,
      )}</i></span>`.trim()
    }
    const countdownInterval = setInterval(updateCountdown, 1000)

    updateCountdown()

    return true
  })
}
